import { useSelector } from "react-redux";

export default function UniversitySelector({ UniversityId, handleFormChange }) {
  const { UniversityList } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );

  return (
    <>
      <select
        className="form-control"
        placeholder="Enter University"
        name={"University_Id"}
        value={UniversityId}
        onChange={(e) => handleFormChange(e)}
      >
        <option value="">Select University</option>
        {UniversityList?.map((el) => (
          <option key={el.University_Id} value={el.University_Id}>
            {el.University_Name}
          </option>
        ))}
      </select>
    </>
  );
}
